import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { conflictCaseActions } from "../../store/conflictCasesSlice";
import { FaRegWindowClose } from "react-icons/fa";
import "./AlertModal.scss";
import { errorActions } from "../../store/errorSlice";
import { ErrorState } from "../../store/errorSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

/**
 *
 * @param {error} Object Object containing the error details. Needs the following fields: isError, errorTs (for error codes), errorDisplayTime, and errorMessage
 * @param {closeModal} Method Method to hide the modal
 * @param {clearError} Method Method to change the error state back to it's initial state
 * @returns
 */

const AlertModal = () => {
  const errorState = useAppSelector((state) => state.error);
  const dispatch = useAppDispatch();
  const [currentAlertModalProp, setCurrentAlertModalProp] = useState(<></>);

  const { isError, errorMessage, errorTs, errorDisplayTime } = errorState.error;

  const closeModal = () => {
    dispatch(errorActions.hideError());
  };

  const clearError = () => {
    dispatch(errorActions.clearError());
  };

  useEffect(() => {
    setCurrentAlertModalProp(
      <div>
        <p>{errorMessage}</p>
        {errorTs !== "" && errorTs !== null && (
          <p className="italic">Errorcode: {errorTs}</p>
        )}
      </div>
    );

    let alertModalPromise1 = setTimeout(() => {
      closeModal();
    }, errorDisplayTime);

    let alertModalPromise2 = setTimeout(() => {
      clearError();
    }, errorDisplayTime + 1000);

    return () => {
      clearTimeout(alertModalPromise1);
      clearTimeout(alertModalPromise2);
    };
  }, [isError]);

  return (
    <>
      <div
        className={
          "alert-modal-container error-state " +
          (isError === "ERROR" ? "visible" : "hidden")
        }
      >
        <div
          className="alert-modal-close-button-container"
          onClick={closeModal}
        >
          <FaRegWindowClose fontSize="1.5rem" />
        </div>
        {currentAlertModalProp}
      </div>
      <div
        className={
          "alert-modal-container info-state " +
          (isError === "INFO" ? "visible" : "hidden")
        }
      >
        <div
          className="alert-modal-close-button-container"
          onClick={closeModal}
        >
          <FaRegWindowClose fontSize="1.5rem" />
        </div>
        {currentAlertModalProp}
      </div>
    </>
  );
};

export default AlertModal;
